































































































import Vue from 'vue'
import AddTopUp from '@/components/Services/TopUps/AddTopUp.vue'
import AddMultipleTopUp from '@/components/Services/TopUps/AddMultipleTopUp.vue'
import { AxiosResponse } from 'axios'
import {
  TopupRequests,
  TopUpAgent,
  GetProductDTO,
  TopUpDeal,
} from '@/utils/interfaces/topup.interface'
import {
  getPreTopupStatus,
  getProducts,
  getTopUpAgentById,
  getTopUpDeals,
} from '@/api/Topup/topup.api'
import ExitDialog from '@/components/Services/TopUps/ExitDialog.vue'
import { TranslateResult } from 'vue-i18n'
import { productsEnum } from '@/utils/productsCode.constant'
import SuccessSnackbar from './SuccessSnackbar.vue'
import DealDetailsDialog from './DealDetailsDialog.vue'
import TextButton from '~/components/TextButton.vue'

export default Vue.extend({
  components: {
    appAddTopUp: AddTopUp,
    appAddMultipleTopUp: AddMultipleTopUp,
    appExitDialog: ExitDialog,
    SuccessSnackbar,
    DealDetailsDialog,
    TextButton,
  },
  data() {
    return {
      tabs: 0,
      loading: false,
      showSuccess: false,
      rows: 10,
      products: [] as GetProductDTO[],
      defaultProduct: '',
      agent: {} as TopUpAgent,
      exitDialog: false,
      exitText: '' as string | TranslateResult,
      to: { name: 'topup.list' },
      preTopupStatus: false,
      deals: [] as TopUpDeal[],
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    getAgentInfo() {
      getTopUpAgentById(this.$store.getters.profile.uuid)
        .then(response => {
          this.agent = response.data
          if (!this.agent.topup_credit) {
            this.exitText = this.$t('topup.no-credit')
            this.to = { name: 'topup.credit-transfer' }
            this.exitDialog = true
          }
        })
        .catch(() => {
          this.exitText = this.$t('topup.no-price-assigned')
          this.to = { name: 'topup.price-config' }
          this.exitDialog = true
        })
    },
    async onCreate() {
      let target: string
      if (this.tabs) {
        target = 'multiple'
      } else target = 'single'
      this.loading = true

      try {
        const component = this.$refs[target] as Vue & {
          createTopUp: () => Promise<void | AxiosResponse<TopupRequests>>
        }
        const response = await component.createTopUp()
        if (response) {
          this.showSuccess = true
          setTimeout(() => {
            this.showSuccess = false
          }, 5000)
          if (!this.$p.isEmployee) this.getAgentInfo()
        }
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    if (!this.$p.isEmployee) this.getAgentInfo()

    getProducts({
      limit: 100,
      code__in: `${productsEnum.TOPUP},${productsEnum.PACKAGE}`,
      show_to_clients: true,
    }).then(response => {
      this.products = response.data.results.map(i => ({
        ...i,
        text: `${i.amount} - ${this.$t(i.code)} ${i.destination_amount}`,
      }))
    })

    getTopUpDeals({
      end_date__gte: new Date().toISOString().substring(0, 10),
    }).then(response => {
      this.deals = response.data.results
    })

    this.preTopupStatus = (await getPreTopupStatus()).data.status
  },
})
